import AudiencePage from "@/components/AudiencePage";

export default function Consultants() {
  return (
    <AudiencePage
      testId="consultants-page"
      overline="For Consultants · Create & Deliver"
      title="Deliver ADAC XML right the first time."
      subtitle="Build compliant ADAC files, pre-validate against the exact Council standard, and profile data quality before delivery — so you cut rejections and costly rework."
      image="https://images.unsplash.com/photo-1607134541550-2994abb8077b?auto=format&fit=crop&w=1000&q=70"
      pains={[
        "Deliverables rejected for issues that should have been caught earlier.",
        "Rebuilding and resubmitting files — burning time and margin.",
        "Guessing at the Council's acceptance rules until it's too late.",
        "No quick way to profile data quality before handover.",
      ]}
      gains={[
        "Produce ADAC-compliant XML with checks built into the workflow.",
        "Pre-validate against the same standard Councils use to accept.",
        "Profile data quality and continuity before you deliver.",
        "Generate validation reports to ship alongside your deliverable.",
        "Cut rejections, protect margin, and deliver with confidence.",
      ]}
    />
  );
}
